import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawSummary(doc, summary, grandTotal,) {
  // doc.setFontSize(14);
  //doc.setFont("helvetica", "bold");
  // doc.text("CALCULATION SUMMARY ", 14, 20);
  //console.log ("Summery Data" , grandTotal);




  autoTable(doc, {
    startY: doc.lastAutoTable
      ? doc.lastAutoTable.finalY + 5
      : 120,
    ...PDF_TABLE_STYLE,
   
    theme: "grid",
tableWidth: 275,
    head: [["", "WO No", "LOCO", "C&W", "MISC", ""]],

    body: [
      ["No. WA/SL/Repair Cost ", "", "", "", "", "",],
      ["Dy CME Repair ", "", "", "", "", "",],
      ["No. WA/SL/Repair Cost ", "", "", "", "", "",],

      ["", ""],


    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING1,
      //cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING1,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING1,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "left",
        cellWidth: 60,
        minCellHeight:10,
      },
      1: {
        halign: "right",
        cellWidth: 43,
      },
      2: {
        halign: "right",
        cellWidth: 43,
      },
      3: {
        halign: "right",
        cellWidth: 43,
      },
      4: {
        halign: "right",
        cellWidth: 43,
      },

      5: {
        halign: "right",
        cellWidth: 43,
      },
    },

   
  });


  // FA&CAO/W outside the table
const y = doc.lastAutoTable.finalY + 30;

doc.setFontSize(9);
doc.setFont("helvetica", "bold");

doc.text(
  "for FA&CAO/W",
  270,       // right-side X position
  y,
  { align: "right" }
);
}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}